// extracted by mini-css-extract-plugin
module.exports = {"selectionBar":"Chooser_selectionBar__15DJ7","selection":"Chooser_selection__2FmHP","finalSelection":"Chooser_finalSelection__39CkV","note":"Chooser_note__3oVU_"};